import React, { useState } from 'react';
import { PAY_METHODS, recordPayment } from '../../services/jobs';
import '../Calls/FollowUpDetail.css';

/**
 * Any staff (agents collect cash too, 2026-11-03): a payment that didn't come through the card page (e-transfer, cash, cheque) → saved in Books against
 * the job's invoice; the payment sync then updates paid / balance in Zoho and ticks Deposit / Final payment.
 */
const pad = (n) => String(n).padStart(2, '0');
const todayLocal = () => {
  const d = new Date();
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

const RecordPayment = ({ job, onToast }) => {
  const [open, setOpen] = useState(false);
  const [amount, setAmount] = useState('');
  const [method, setMethod] = useState('etransfer');
  const [date, setDate] = useState(todayLocal());
  const [reference, setReference] = useState('');
  const [busy, setBusy] = useState(false);
  const owing = Number(job.balance || 0);

  if (!open) {
    return (
      <button type="button" className="status-cancel pay-open" onClick={() => setOpen(true)}>
        + Record e-transfer / cash / cheque
      </button>
    );
  }
  const save = async () => {
    setBusy(true);
    try {
      onToast(await recordPayment(job.id, { amount, method, date, reference }));
      setOpen(false);
      setAmount('');
      setReference('');
    } catch (err) {
      onToast(`⚠ ${err.message}`);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="step-form pay-form">
      <div className="fud-quote-chips">
        {PAY_METHODS.map(([id, label]) => (
          <button key={id} type="button" className={`fud-quote-chip${method === id ? ' active' : ''}`} onClick={() => setMethod(id)}>
            {label}
          </button>
        ))}
      </div>
      <label>
        Amount
        <input type="number" inputMode="decimal" min="0" step="0.01" value={amount} onChange={(e) => setAmount(e.target.value)} placeholder={owing ? `Up to ${owing.toFixed(2)}` : '0.00'} />
      </label>
      {owing > 0 && (
        <button type="button" className="plan-link pay-full" onClick={() => setAmount(owing.toFixed(2))}>
          Full balance ${owing.toFixed(2)}
        </button>
      )}
      <label>
        Received on
        <input type="date" value={date} max={todayLocal()} onChange={(e) => setDate(e.target.value)} />
      </label>
      <label>
        Reference <span className="status-optional">optional</span>
        <input value={reference} onChange={(e) => setReference(e.target.value)} placeholder="e-Transfer ref / cheque #" maxLength={50} />
      </label>
      <div className="plan-actions">
        <button type="button" className="status-cancel" onClick={() => setOpen(false)} disabled={busy}>Cancel</button>
        <button type="button" className="status-save" onClick={save} disabled={busy || !(Number(amount) > 0) || !date}>
          {busy ? 'Saving…' : `Record $${Number(amount || 0).toFixed(2)}`}
        </button>
      </div>
    </div>
  );
};

export default RecordPayment;
